import ApiSDKError from './ApiSDKError'

export default class MisconfigurationError extends ApiSDKError {
    constructor(message: string) {
        super(`Incorrect request setup: ${message}`);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = 'MisconfigurationError';
    }
}
